import { TableRow } from '@material-ui/core';
import styled from 'styled-components';

export const StyledCTPTAbleSubRow = styled(TableRow)`
  .subrow-actions {
    .wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
`;
